// @ts-nocheck
export const parseIntSafely = (input) => {
	return input ? parseInt(input) : undefined;
};
